import { render, staticRenderFns } from "./ShopStoreGroupbuy.vue?vue&type=template&id=38fe267e&scoped=true&"
import script from "./ShopStoreGroupbuy.vue?vue&type=script&lang=js&"
export * from "./ShopStoreGroupbuy.vue?vue&type=script&lang=js&"
import style0 from "./ShopStoreGroupbuy.vue?vue&type=style&index=0&id=38fe267e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe267e",
  null
  
)

export default component.exports